import { render, staticRenderFns } from "./my-tickets.vue?vue&type=template&id=0bc120a4&scoped=true"
import script from "./my-tickets.vue?vue&type=script&lang=js"
export * from "./my-tickets.vue?vue&type=script&lang=js"
import style0 from "./my-tickets.vue?vue&type=style&index=0&id=0bc120a4&prod&lang=scss&scoped=true"
import style1 from "./my-tickets.vue?vue&type=style&index=1&id=0bc120a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc120a4",
  null
  
)

export default component.exports